// @flow
import * as React from 'react'
import { useHistory } from 'react-router'
import ErrorPage from 'ui/organisms/ErrorPage'
import { ZentakeContext } from 'utils/ZentakeContext'

import { useLoadStripeCustomer } from '@/queries/payments/useLoadStripeCustomer'

function ClosedAccountPage(): React.Node {
  const { teamDetails } = React.useContext(ZentakeContext)
  const history = useHistory()
  const { data: stripeCustomer } = useLoadStripeCustomer()

  const { subscription_status } = stripeCustomer ?? {}

  React.useEffect(() => {
    if (!teamDetails || !stripeCustomer) {
      return
    }

    if (subscription_status !== 'canceled' && teamDetails?.is_active === true) {
      history.push('/')
    }
  }, [
    teamDetails?.is_active,
    history,
    teamDetails,
    stripeCustomer,
    subscription_status,
  ])

  const handleClick = () => {
    const contactUs = 'https://help.zentake.com/'
    window.open(contactUs)
  }

  return (
    <ErrorPage
      buttonText="Contact Us"
      heading="This account has been closed."
      onClick={handleClick}
      text="Contact us if you need any help"
    />
  )
}

export default ClosedAccountPage
